import { render, staticRenderFns } from "./ChartPrpPorCompetencia.vue?vue&type=template&id=772667dd&"
import script from "./ChartPrpPorCompetencia.vue?vue&type=script&lang=js&"
export * from "./ChartPrpPorCompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports